import React from "react";

export const InfoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle
      cx="8"
      cy="8"
      r="7"
      stroke="rgba(255,255,255,0.48)"
      strokeWidth="1.5"
    />
    <path
      d="M8 7v4M8 5h.01"
      stroke="rgba(255,255,255,0.48)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
